import React from "react";
import { Grid, SvgIcon, Typography } from "@material-ui/core";

const ServiceLabelWithIcon = ({ icon, label }) => {
  return (
    <Grid container justify="center" alignItems="center" spacing={1}>
      <Grid item>
        <SvgIcon style={{ fontSize: 16 }}>{icon}</SvgIcon>
      </Grid>
      <Grid item>
        <Typography align="center" variant="h3" component="p">
          <strong>{label}</strong>
        </Typography>
      </Grid>
    </Grid>
  );
};

export { ServiceLabelWithIcon };
